import { localizedPath } from './i18nPath'
import { DEFAULT_LOCALE, PREFIX_LOCALES, type Locale } from './locales'
import { normalizeLocale } from '@/utils/locale'
import { i18n } from '@/plugins/i18n'

export const localizedPageSlugs = {
  memberships: { no: 'medlemskap', en: 'memberships' },
  customerService: { no: 'kundeservice', en: 'customer-service' },
  gymOverview: { no: 'treningssenter', en: 'gyms' },
  trainerOverview: { no: 'personlig-trener', en: 'personal-trainer' },
  about: { no: 'om-fitnessroom', en: 'about-fitnessroom' },
  membershipTerms: { no: 'medlemsvilkar', en: 'membership-terms' },
  privacy: { no: 'personvern', en: 'privacy' },
} as const satisfies Record<string, Record<Locale, string>>

export type LocalizedPageKey = keyof typeof localizedPageSlugs

function resolveLocale(localeOverride?: Locale): Locale {
  if (localeOverride) return localeOverride

  const activeLocale = normalizeLocale(String(i18n.global.locale.value || DEFAULT_LOCALE))
  return ((PREFIX_LOCALES as readonly string[]).includes(activeLocale) ? activeLocale : DEFAULT_LOCALE) as Locale
}

export function getLocalizedPageSlug(key: LocalizedPageKey, localeOverride?: Locale): string {
  const locale = resolveLocale(localeOverride)
  return localizedPageSlugs[key][locale]
}

export function localizedPagePath(key: LocalizedPageKey, localeOverride?: Locale): string {
  return localizedPath('page', { slug: getLocalizedPageSlug(key, localeOverride) }, localeOverride)
}

export function translateKnownPageSlug(slug: string, targetLocale: Locale): string {
  const match = Object.entries(localizedPageSlugs).find(([, localeMap]) =>
    (Object.values(localeMap) as string[]).includes(slug),
  )

  if (!match) return slug

  const [key] = match as [LocalizedPageKey, (typeof localizedPageSlugs)[LocalizedPageKey]]
  return localizedPageSlugs[key][targetLocale]
}
